import { render } from "./GoBillingSelector.vue?vue&type=template&id=e45bb56a&scoped=true"
import script from "./GoBillingSelector.vue?vue&type=script&lang=js"
export * from "./GoBillingSelector.vue?vue&type=script&lang=js"

import "./GoBillingSelector.vue?vue&type=style&index=0&id=e45bb56a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e45bb56a"]])

export default __exports__